angular.module('zc.master.zcliteProjects', [
  'zc.master'
])




// WEBPACK FOOTER //
// ./src/master_admin_modules/master.zclite_projects/index.coffee